import {
  PasswordRecoveryPages,
  StartAsPage,
} from "@/app/[locale]/auth/login/components/types";
import { RegistrationErrorResponse } from "@/lib/auth/registerUser";
import { buildSafeUrlWithBase } from "@/utils/functions/buildSafeUrl";

export enum UrlKind {
  AbsolutePath,
  RelativePath,
  AbsoluteUrl,
}

const pageMapping = [
  [StartAsPage.Login, true],
  [StartAsPage.Register, true],
  [StartAsPage.ForgotPassword, true],
  [StartAsPage.ForgotPasswordConfirm, false],
] as [/* page */ StartAsPage, /* path.endsWith */ boolean][];

export function pathToAuth(
  page: StartAsPage,
  kind: UrlKind = UrlKind.AbsolutePath,
) {
  const urlPath = `${kind !== UrlKind.RelativePath ? "/" : ""}auth/${page}`;

  if (kind == UrlKind.AbsoluteUrl && typeof window !== "undefined") {
    return buildSafeUrlWithBase(window.location.href, urlPath);
  }
  return urlPath;
}

export function pathToPage(path: string) {
  let startPage = StartAsPage.Login;
  pageMapping.forEach(([page, endsWith]) => {
    if (endsWith && path.endsWith(page)) {
      startPage = page;
    } else if (path.includes(page)) {
      startPage = page;
    }
  });

  return startPage;
}

export function isPasswordRecoveryPage(currentPage: StartAsPage): boolean {
  return PasswordRecoveryPages.includes(currentPage);
}

export function cleanUpHtml(sus: string) {
  const noTags = sus.replace(/<\/?[^>]+(>|$)/g, "");

  const withNumeric = noTags
    .replace(/&#(\d+);/g, (_, dec) => String.fromCharCode(parseInt(dec, 10)))
    .replace(/&#x([0-9a-fA-F]+);/g, (_, hex) =>
      String.fromCharCode(parseInt(hex, 16)),
    );

  // Step 3: Iteratively decode common named entities
  const namedEntities: Record<string, string> = {
    "&nbsp;": " ",
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&apos;": "'",
    "&cent;": "¢",
    "&pound;": "£",
    "&yen;": "¥",
    "&euro;": "€",
    "&copy;": "©",
    "&reg;": "®",
  };

  const namedPattern = new RegExp(Object.keys(namedEntities).join("|"), "g");
  let decoded = withNumeric;
  let previous;
  do {
    previous = decoded;
    decoded = decoded.replace(namedPattern, (match) => namedEntities[match]);
  } while (decoded !== previous);

  return decoded;
}

export function getUserFieldErrorMessage(result: RegistrationErrorResponse) {
  const registrationErrorResponse = result;
  const errorMessage =
    typeof registrationErrorResponse === "object"
      ? (registrationErrorResponse.error_message as {
          user_message: string;
        }[])
      : null;
  return errorMessage?.at(0)?.user_message || JSON.stringify(result);
}
